import {Injectable} from "@angular/core";

/**
 * Service de gestion du suivi des relevés de cartes
 *
 * @author Guillaume TRAVOT
 * @date 18/03/2026
 */
@Injectable()
export class SuiviReleveService {
    /** Liste des relevés dépliés */
    private listeUnfoldedReleve = new Set<number>();

    /**
     * Vérifie si un relevé est déplié
     *
     * @param idRacine ID de la racine à vérifier
     */
    isReleveUnfolded(idRacine: number): boolean {
        return this.listeUnfoldedReleve.has(idRacine);
    }

    /**
     * Change le statut plié/déplié d'un relevé
     *
     * @param idRacine ID de la racine concernée
     * @param isUnfolded true si déplié, false sinon
     */
    setReleveFoldedUnfolded(idRacine: number, isUnfolded: boolean): void {
        //Si déplié demandé
        if (isUnfolded) {
            //Ajout à la liste
            this.listeUnfoldedReleve.add(idRacine);
        } else {
            //Sinon, suppression de la liste
            this.listeUnfoldedReleve.delete(idRacine);
        }
    }
}